import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaPhoneAlt, FaEnvelope, FaCheckCircle, FaClock } from 'react-icons/fa';
import mainlogo from '../assets/main-logo.png';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section logo-section">
          <img className="footer-logo" src={mainlogo} alt="ISKCON Ujjain"/>
          <p>
            Address: Hare Krishna Land, 33-37, Administrative Zone, Bharatpuri, Ujjain, Madhya Pradesh 456010          </p>
          {/* <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaYoutube /></a>
          </div> */}
        </div>

        <div className="footer-section">
          <h4>Timing</h4>
          <ul>
            <li><FaClock /> Samadhi Arati – 04:10AM</li>
            <li><FaClock /> Mangala Arati – 04:30AM</li>
            <li><FaClock /> Tulsi-Puja – 05:00AM</li>
            <li><FaClock /> Sringar Darshan – 07:15AM</li>
            <li><FaClock /> Guru Puja – 07:25AM</li>
            <li><FaClock /> Bhagavatam Class – 08:00AM</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Our Services</h4>
          <ul>
            <li><FaCheckCircle /> Simple Living, High Thinking</li>
            <li><FaCheckCircle /> Srila Prabhupada Audiobooks</li>
            <li><FaCheckCircle /> Life Membership</li>
            <li><FaCheckCircle /> Community Service Centre</li>
            <li><FaCheckCircle /> Gomata Products</li>
            <li><FaCheckCircle /> Buy Books Online</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Us</h4>
          <ul>
            <li><FaPhoneAlt /> +917618183108</li>
            <li><FaEnvelope /> info@iskconujjain.com</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom center">
        <p>©2025 ISKCON Ujjain. All rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
